// CardSection.js
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {CardNumberElement,CardCVCElement,CardExpiryElement,PostalCodeElement} from 'react-stripe-elements';
import { addCard,getCards } from '../../actions/payment';
import { NotificationManager } from 'react-notifications';
import store from './../../store';

const $ = window.$;
const createOptions = () => {
    return {
      style: {
        base: {
          fontSize: '16px',
          color: '#323232',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#c23d4b',
        },
      },
    };
  };
class CardSection extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        errorMessage: '',
    };
    
    handleChange = ({error}) => {
    if (error) {
        this.setState({errorMessage: error.message});
    }
    };
    componentWillReceiveProps= (nextProps) => {
        if(this.props.addedCard !== nextProps.addedCard) {
            this.setState({loading:false});
            this.props.getCards();
            NotificationManager.success("Card added succesfully.")
            $('#add_payment_modal').modal('hide');
        }
        if(this.props.addedCardError!==this.props.addedCardError){
            this.setState({loading:false})
            NotificationManager.error("Something went wrong.")
            $('#add_payment_modal').modal('hide');
        }
        
    }
    handleSubmit = (evt) => {
        evt.preventDefault();
        if (this.props.stripe) {
            this.props.stripe.createToken().then((response)=>{
                if(response.error){
                    NotificationManager.error(response.error.message);
                }else{
                    let data = {
                        card_token:response.token,
                        user:store.getState().userReducer.currentUser
                    }
                    this.props.addCard(data);

                }
            }).catch((error)=>{
                NotificationManager.error('Something went wrong');
            });
        } else {
        }
    }
    // getCards = () =>{
    //     this.props.getCards();
    // }
    render() {
        return (
            <div className="stripe-payment col-lg-12">
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">
                            <label>
                                Card number
                                <CardNumberElement
                                {...createOptions()}
                                onChange={this.handleChange}
                                />
                            </label>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <label>
                                Expiration date
                                <CardExpiryElement
                                {...createOptions()}
                                onChange={this.handleChange}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">
                            <label>
                                CVC
                                <CardCVCElement {...createOptions()} onChange={this.handleChange} />
                            </label>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <label>
                                Postal Code
                                <PostalCodeElement {...createOptions()} onChange={this.handleChange} />
                            </label>
                        </div>
                        
                    </div>
            <div className="error" role="alert">
            {this.state.errorMessage}
            </div>
            <button>Pay</button>
        </form>
        </div>
        );
    }  
}
const mapStateToProps = state =>({
    petShop:state.petShopReducer,
    addedCard:state.paymentReducer.addedCard,
    addedCardError:state.paymentReducer.addedCardError
});
const mapDispatchToProps = dispatch => ({
    addCard : (card) => {
        dispatch(addCard(card));
    },
    getCards : ()=>{
        dispatch(getCards());
    }
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardSection));;